import { Box } from '@mui/material';
import React from 'react';

import { useScope, useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import CustomerTitleItems from '@sophocles/components/App/CustomerTitleItems';
import TitleBar from '@sophocles/components/App/TitleBar';

import CurfewReportGrid from './components/CurfewReportGrid';

function CustomerCurfewReportView(props) {
  const {
    match: { params },
  } = props;

  const { customer } = useScope();
  const { user } = useUser();

  return (
    <AppNav flex notFullHeight page="customer_reports" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar
          showBackButton
          title="Curfew Report"
          items={<CustomerTitleItems user={user} customer={customer} params={params} page="reports" />}
        />
        <CurfewReportGrid customerId={customer?.id} />
      </Box>
    </AppNav>
  );
}

export default CustomerCurfewReportView;
